import { ALMACEN } from "./modulos/almacen.environment";
import { HOME } from "./modulos/home.environment";
import { PANELCONTROL } from "./modulos/panelcontrol.environment";
import { CONTABILIDAD } from "./modulos/contabilidad.environment";
import { PRODUCTIVIDAD } from "./modulos/productividad.environment";
import { FACTURAS } from "./modulos/facturas.environment";
import { VO } from "./modulos/vo.environment";
import { CONECTIVIDAD } from "./modulos/conectividad";
import { GENERAL } from "./modulos/general.environment";
import { TALLER } from "./modulos/taller.environment";
import { GRC } from "./modulos/grc.environment";
import { BUSCADOR } from "./modulos/buscador.environment";
import {environment} from './environment';

export const API = {
    General: "Services/General/",
    Session: "Services/Session/",
    BaseServices: "Services/BaseServices/",
    Workshop: "Services/Workshop/",
    Invoicing: "Services/Invoicing/",
    // VO: 'Services/VO/VOCustomerService.svc/',
    Vho: "Services/VO/",
    Taller: "ServiciosTaller.ServicioVehiculos",
    WareHouse: "Services/WareHouse/",
    URL: "Services/Session/SessionService.svc/",
    URL_General: "Services/General/CustomerService.svc/",
    URL_CustomerCategory: "Services/General/CustomerCategoryService.svc/",
    URL_Identification: "Services/General/CustomerIdentificationService.svc/",
    URL_GESTION_VEHICULOS: "Services/Workshop/VehicleService.svc/",
    TALLER: "Services/General/CustomerService.svc/",
    ConfigTaller: "Services/General/WorkshopConfigurationsService.svc",
    URL_ISOCodesService: "Services/General/ISOCodesService.svc/",
    URL_BaseServices: "Services/BaseServices/ArcadService.svc/",
    Url_VatTypeService: "Services/General/VatTypeService.svc/",
    ProductionOrderValuation: "Services/Workshop/RepairOrderService.svc/ProductionOrderValuation",
    ProductionOrderValuationPT: "Services/Workshop/BudgetService.svc/ProductionOrderValuation",
    Brand: "Services/Brand/",
    ALMACEN: ALMACEN,
    HOME: HOME,
    PANELCONTROL: PANELCONTROL,
    CONTABILIDAD: CONTABILIDAD,
    PRODUCTIVIDAD: PRODUCTIVIDAD,
    FACTURAS: FACTURAS,
    CONECTIVIDAD: CONECTIVIDAD,
    VO: VO,
    GENERAL: GENERAL,
    TALLER2: TALLER,
    GRC: GRC,
    BUSCADOR: BUSCADOR,
    ENDPOINT: {
        GetCurrentCulture: "GetCurrentCulture",
        GetCurrentFilial: "GetCurrentFilial",
        GetCurrentVersion: "GetCurrentApplicationVersion",
        GetInitializationState: "GetInitializationState",
        Login: "Login",
        GetPageCountAlphabetical: "GetPageCountAlphabetical",
        add_Favorite: "AddFavorite",
        delete_Favorite: "DeleteFavorite",
        FindPaged: "FindPaged",
        FindPRPaged: "FindPRPaged",
        GetPageCount: "GetPageCount",
        GetAll: "GetAll",
        GetByCustomerCodeWithContacts: "GetByCustomerCodeWithContacts",
        GetCustomerCourtesies: "GetCustomerCourtesies",
        GetExempted: "VatTypeService.svc/GetExempted",
        LaborDiscountCodesService: "LaborDiscountCodesService.svc/GetAll",
        CustomerPRDiscountsService: "CustomerPRDiscountsService.svc/GetAll",
        PaymentTypesService: "PaymentTypesService.svc/GetByType",
        GetBbanStructures: "BankService.svc/GetBbanStructures",
        ValidateIban: "BankService.svc/ValidateIban",
        ValidateFiscalCode: "ValidateFiscalCode",
        GetByCustomerCode: "VehicleService.svc/GetByCustomerCode",
        CanBeDeleted: "CustomerService.svc/CanBeDeleted",
        IsDeactivated: "CustomerService.svc/IsDeactivated",
        CanBeDeactivated: "CustomerService.svc/CanBeDeactivated",
        Deactivate: "CustomerService.svc/Deactivate",
        Reactivate: "CustomerService.svc/Reactivate",
        CustomerDelete: "CustomerService.svc/Delete",
        GetUniqueSearchCode: "CustomerService.svc/GetUniqueSearchCode",
        Update: "CustomerService.svc/Update",
        AddTicket: "SupportTicketsService.svc/AddTicket",
        AddTicketOnline: "SupportTicketsService.svc/AddTicketOnline",
        SMSSend: "SMSService.svc/SMSSend",
        SendMessage: "EmailService.svc/SendMessage",
        GetUserProfileByApplicationType:
            // tslint:disable-next-line: quotemark
            "UserProfileService.svc/GetUserProfileByApplicationType",
        GetBySearchCode: "CustomerService.svc/GetBySearchCode",
        Add: "CustomerService.svc/Add",
        // Taller-Matenemiento-Garantee
        // tslint:disable-next-line: quotemark
        GaranteeExtensionsService: "GaranteeExtensionsService.svc/GetAll",
        GaranteeExtensionsAdd: "GaranteeExtensionsService.svc/Add",
        GaranteeExtensionsUpdate: "GaranteeExtensionsService.svc/Update",
        GaranteeExtensionsDelete: "GaranteeExtensionsService.svc/Delete",
        WorkingSections: "WorkingSectionService.svc/GetAllWorkingSections",
        OrderStates: "OrderStatesService.svc/GetAll",
        // Taller-Matenemiento-3102 OPB
        GetAllModelsOPB: "VehicleModelService.svc/GetAllModelsOPB",
        ModelsOPBAdd: "VehicleModelService.svc/Add",
        ModelsOPBDelete: "VehicleModelService.svc/Delete",
        ModelsOPBUpdate: "VehicleModelService.svc/Update",
        // Taller-Matenemiento-Precios 3103 MO
        PricesOperationTypes: "OperationTypesService.svc/GetAll",
        PricesOperationTypesAdd: "OperationTypesService.svc/Add",
        PricesOperationTypesUpdate: "OperationTypesService.svc/Update",
        PricesOperationTypesDelete: "OperationTypesService.svc/Delete",
        // Taller-Matenemiento-TiposOR
        GetAllORTypes: "OrderSubTypesService.svc/GetAllQuery",
        // Taller-Matenemiento-3107 marcas Vehiculos
        VehicleBrands: "VehicleBrandService.svc/GetAllVehicleBrands",
        // Taller-Matenemiento- 3108 mODELOD Vehiculos
        VehicleModel: "VehicleModelService.svc/GetAllModels",
        // Taller-Matenemiento- 3109 Secciones Internas
        InternalSections: "InternalSectionsService.svc/GetAll",
        InternalSectionsAdd: "InternalSectionsService.svc/Add",
        InternalSectionsUpdate: "InternalSectionsService.svc/Update",
        InternalSectionsDelete: "InternalSectionsService.svc/Delete",
        // Taller-Matenemiento-configuracion de precios de mano de obra por sector taller
        MOConfigurations: "MOConfigurationsService.svc/GetAll",
        MOConfigurationsUpdate:
            "MOConfigurationsService.svc/UpdateConfiguration",
        // Taller-Matenemiento-3110-tipos hora
        HourType: "HourTypeService.svc/FindHourTypes",
        HourTypeAdd: "HourTypeService.svc/Add",
        HourTypeUpdate: "HourTypeService.svc/Update",
        HourTypeDelete: "HourTypeService.svc/Delete",
        // Taller-Matenemiento-3111-Defectos Padre de garantias
        GaranteeDefects: "GaranteeDefectsService.svc/GetAllParent",
        GaranteeDefectsAdd: "GaranteeDefectsService.svc/Add",
        GaranteeDefectsUpdate: "GaranteeDefectsService.svc/Update",
        GaranteeDefectsDelete: "GaranteeDefectsService.svc/Delete",
        // Taller-Matenemiento-3112-Defectos hijo de garantias
        GaranteeDefectChild: "GaranteeDefectsService.svc/GetAll",
        GaranteeDefectChildAdd: "GaranteeDefectsService.svc/AddDefectChild",
        GaranteeDefectChildUpdate:
            "GaranteeDefectsService.svc/UpdateDefectChild",
        GaranteeDefectChildDelete:
            "GaranteeDefectsService.svc/DeleteDefectChild",
        // Taller-Matenemiento-3113-Imputacion garantias
        GaranteeAllegation: "GaranteeAllegationService.svc/GetAll",
        GaranteeAllegationAdd: "GaranteeAllegationService.svc/Add",
        GaranteeAllegationUpdate: "GaranteeAllegationService.svc/Update",
        GaranteeAllegationDelete: "GaranteeAllegationService.svc/Delete",
        // Taller-Matenemiento-3114-Descuentos garantias
        GaranteeDiscounts: "GaranteeDiscountsService.svc/GetAll",
        GaranteeDiscountsAdd: "GaranteeDiscountsService.svc/Add",
        GaranteeDiscountsUpdate: "GaranteeDiscountsService.svc/Update",
        GaranteeDiscountsDelete: "GaranteeDiscountsService.svc/Delete",
        // Taller-Matenemiento-3116- DTO MO
        LaborDiscountCodes: "LaborDiscountCodesService.svc/GetAll",
        LaborDiscountCodesAdd: "LaborDiscountCodesService.svc/Add",
        LaborDiscountCodesUpdate: "LaborDiscountCodesService.svc/Update",
        LaborDiscountCodesDelete: "LaborDiscountCodesService.svc/Delete",
        // Taller-Matenemiento-3117  Forfait local
        LocalForfaits: "LocalForfaitsService.svc/GetAll",
        LocalForfaitsUpdate: "LocalForfaitsService.svc/Update",
        LocalForfaitsDelete: "LocalForfaitsService.svc/Delete",
        LocalForfaitsAdd: "LocalForfaitsService.svc/Add",
        // Taller-Matenemiento-3118  Residuos
        WasteManagement: "WasteManagementService.svc/GetAll",
        WasteManagementAdd: "WasteManagementService.svc/Add",
        WasteManagementUpdate: "WasteManagementService.svc/Update",
        WasteManagementDelete: "WasteManagementService.svc/Delete",
        // Taller-Matenemiento-3119 Forfait nacional
        Forfait: "ForfaitService.svc/GetAll",
        // Taller-Matenemiento-3120
        ForfaitZones: "ForfaitZonesService.svc/GetAll",
        ForfaitZonesDelete: "ForfaitZonesService.svc/Delete",
        ForfaitZonesUpdate: "ForfaitZonesService.svc/Update",
        ForfaitZonesAdd: "ForfaitZonesService.svc/Add",
        // Taller-Matenemiento-3121-Types d'intervention
        InterventionTypes: "InterventionTypesService.svc/GetAll",
        // General-Matenemiento-CodigoISO
        ISOCodesComboTipoIso: "GetIsoTypes",
        ISOCodes: "ISOCodesService.svc/GetAll",
        ISOCodesAdd: "ISOCodesService.svc/Add",
        ISOCodesUpdate: "ISOCodesService.svc/Update",
        ISOCodesDelete: "ISOCodesService.svc/Delete",
        // General-Matenemiento-1102- Formas de pagos
        PaymentTypes: "PaymentTypesService.svc/GetAll",
        PaymentTypesAdd: "PaymentTypesService.svc/Add",
        PaymentTypesUpdate: "PaymentTypesService.svc/Update",
        PaymentTypesDelete: "PaymentTypesService.svc/Delete",
        GetExpirationDraftTypes:
            "PaymentTypesService.svc/GetExpirationDraftTypes",
        // General-Matenemiento-1103- categorias clientes
        CustomerCategory: "CustomerCategoryService.svc/GetAll",

        // General-Matenemiento-Categoría Descuento en ventas1104
        CustomerPRDiscounts: "CustomerPRDiscountsService.svc/GetAll",
        CustomerPRDiscountsAdd: "CustomerPRDiscountsService.svc/Add",
        CustomerPRDiscountsUpdate: "CustomerPRDiscountsService.svc/Update",
        CustomerPRDiscountsDelete: "CustomerPRDiscountsService.svc/Delete",
        // General-Matenemiento-1105- DocumentsEnumeration
        DocumentsEnumeration:
            "DocumentsEnumerationService.svc/GetDocumentEnumerationViewByDocumentPrefix",
        // General-Matenemiento-1106  Serie Documentos
        FindDocumentPrefixesByDocumentType: "DocumentPrefixesService.svc/FindDocumentPrefixesByDocumentType",
        DocumentPrefixes: "DocumentPrefixesService.svc/FindDocumentPrefixes",
        DocumentPrefixesAdd: "DocumentPrefixesService.svc/AddDocumentPrefix",
        DocumentPrefixesUpdate:
            "DocumentPrefixesService.svc/UpdateDocumentPrefix",
        DocumentPrefixesDelete:
            "DocumentPrefixesService.svc/DeleteDocumentPrefix",
        DocumentPrefixesElegibleDocType:
            "DocumentPrefixesService.svc/GetElegibleDocumentType",
        // General-Matenemiento-Tipo IVA 1107 fALTA EL SERVICIO ADD
        VatType: "VatTypeService.svc/GetAll",
        VatTypeAdd: "VatTypeService.svc/Add",
        VatTypeDelete: "VatTypeService.svc/Delete",
        VatTypeUpdate: "VatTypeService.svc/Update",
        VatPrctMovementsUpdate:
            "VatTypeService.svc/UpdateVatPercentageMovements",
        // General-Matenemiento- Tipo Documento 1108
        DocumentClasses: "DocumentPrefixesService.svc/GetAllDocumentClasses",
        DocumentClassesUpdate: "DocumentTypesService.svc/UpdateDocumentType",
        // General-Matenemiento- Gestin de Bancos 1109
        BanksRegistry: "BanksRegistryService.svc/GetAll",
        AddNewBank: "BanksRegistryService.svc/AddNewBank",
        UpdateBank: "BanksRegistryService.svc/UpdateBank",
        DeleteBank: "BanksRegistryService.svc/DeleteBank",
        ValidateIbanService: "BanksRegistryService.svc/ValidateIban",
        // Gestin de Bancos1110
        Agents: "AgentsService.svc/GetAll",
        AgentAdd: "AgentsService.svc/AddNewAgent",
        AgentUpdate: "AgentsService.svc/UpdateAgent",
        AgentDeactivate: "AgentsService.svc/DeactivateAgent",
        ReactivateAgent: "AgentsService.svc/ReactivateAgent",
        AgentDelete: "AgentsService.svc/DeleteAgent",
        GetNewAgentCode: "AgentsService.svc/GetNewAgentCode",
        GetAllAgentTypes: "AgentsService.svc/GetAllAgentTypes",
        // Atcud - 1111
        AtcudGetAll: "AtcudsService.svc/GetAll",
        AtcudAdd: "AtcudsService.svc/Add",
        AtcudUpdate: "AtcudsService.svc/Update",
        AtcudDelete: "AtcudsService.svc/Delete",
        AtcudGetByDocumentPrefix: "AtcudsService.svc/GetByDocumentPrefix",
        AtcudExistsDocumentsWithPrefix: "AtcudsService.svc/ExistsDocumentsWithPrefix",
        // Facturas- Mantenemientos Centros Administrativos 4201
        PaymentMethods: "PaymentMethodsService.svc/GetAll",
        PaymentMethodsAdd: "PaymentMethodsService.svc/Add",
        PaymentMethodsUpdate: "PaymentMethodsService.svc/Update",
        PaymentMethodsDelete: "PaymentMethodsService.svc/Delete",
        // Facturas- Mantenemientos Centros Administrativos 4202
        AdministrativeCenter: "AdministrativeCenterService.svc/GetAll",
        AdministrativeCenterAdd: "AdministrativeCenterService.svc/Add",
        AdministrativeCenterUpdate: "AdministrativeCenterService.svc/Update",
        AdministrativeCenterDelete: "AdministrativeCenterService.svc/Delete",
        // VO-  Tipos de Gastos de Adecuación  7101
        VOAdequacyCostTypes: "VOAdequacyCostTypesService.svc/GetAll",
        VOAdequacyCostTypesAdd:
            "VOAdequacyCostTypesService.svc/AddNewVOAdequacyCostType",
        VOAdequacyCostTypesUpdate:
            "VOAdequacyCostTypesService.svc/UpdateVOAdequacyCostType",
        VOAdequacyCostTypesDelete:
            "VOAdequacyCostTypesService.svc/DeleteVOAdequacyCostType",
        // VO-  Origen-Destino VO  7103
        VOCarTypes: "VOCarTypesService.svc/GetAll",
        VOCarTypesAdd: "VOCarTypesService.svc/AddNewVOCarType",
        VOCarTypesUpdate: "VOCarTypesService.svc/UpdateVOCarType",
        VOCarTypesDelete: "VOCarTypesService.svc/DeleteVOCarType",
        // VO-   Ubicaciones de Vehículo  7104
        VOLocations: "VOLocationsService.svc/GetAll",
        VOLocationsAdd: "VOLocationsService.svc/AddVOLocation",
        VOLocationsUpdate: "VOLocationsService.svc/UpdateVOLocation",
        VOLocationsDelete: "VOLocationsService.svc/DeleteVOLocation",
        // VO-  Deducciones  7105
        VOTaxDeductions: "VOTaxDeductionsService.svc/GetAll",
        VOTaxDeductionsAdd: "VOTaxDeductionsService.svc/AddVODeduction",
        VOTaxDeductionsUpdate: "VOTaxDeductionsService.svc/UpdateVODeduction",
        VOTaxDeductionsDelete: "VOTaxDeductionsService.svc/DeleteVODeduction",
        GetDdcAcknowledgments: "Services/General/InterfacesMaintenanceService.svc/GetDdcAcknowledgments",
        GetDdcAcknowledgmentsCmb: "Services/General/InterfacesMaintenanceService.svc/GetDdcAcknowledgmentsCmb",
        GetDdcAcknowledgmentsById: "Services/General/InterfacesMaintenanceService.svc/GetDdcAcknowledgmentById",
        VOCarTypeGroups: "VOCarTypesService.svc/GetCarTypeGroups",
        // Almacen- 2101 Almacenes
        WareHousesMant: "WareHousesService.svc/GetAll",
        // Almacen- 2102 codigo cliente
        AccountingCodes: "AccountingCodesService.svc/GetAll",
        // Almacen- 2103 codigo Marcas
        BrandCodes: "BrandCodesService.svc/GetAll",
        // Almacen-Creneau 2104
        CrenauCode: "CrenauCodeService.svc/GetAll",
        //
        // Almacen-DTO Compras 2105
        PurchaseDiscounts: "PurchaseDiscountsService.svc/GetAll",
        // Almacen-Marketing 2106
        MarketingFamilies: "MarketingFamiliesService.svc/GetAll",
        // Almacen-Indice  2107
        MaterialIndexes: "MaterialIndexesService.svc/GetAll",
        // Ecotasa  2108
        EcoTaxes: "EcoTaxesService.svc/GetAll",
        // Almacen-Segmentos  2109
        MaterialSegments: "MaterialSegmentsService.svc/GetAll",
        // Almacen-DTO Ventas  2110
        SaleDiscounts: "SaleDiscountsService.svc/GetAll",

        // Baremos
        WorkingSectionsService:
            "WorkingSectionService.svc/GetAllWorkingSections",
        UserScales: "UserScalesService.svc/GetAll",
        UserScalesAdd: "UserScalesService.svc/Add",
        UserScalesUpdate: "UserScalesService.svc/Update",
        UserScalesDelete: "UserScalesService.svc/Delete",
        UserScalesEdit: "UserScalesService.svc/CanEditDescription",
        GetAllPaged: "UserScalesService.svc/GetAllPaged ",

        // Upload files
        FileUpload: "FileUpload.aspx?responseType=json",
        FileUpload2: "FileUpload.aspx",
        // Interfaces marca
        LoadBaremes: "LoadBaremesService.svc/LoadBaremes",
        LoadMaterials: "LoadMaterialService.svc/LoadMaterials",
        LoadForfaits: 'LoadForfaitService.svc/LoadForfaitV2',
        PreloadMaterial: 'LoadMaterialService.svc/PreloadMaterialFromManualFile',
        LoadMaterialFromXCH: 'LoadMaterialService.svc/LoadMaterialFromXCHManual',
        ApplyPriceIncrement: 'LoadMaterialService.svc/ApplyPriceIncrement',
        GenerateLoadMaterialHistory: 'LoadMaterialService.svc/GenerateLoadMaterialHistory',
        // Gestion terceros
        Undelete: "/Undelete",

        // Fact.Oper
        InvoiceSimulation: "SalesInvoicesService.svc/InvoiceSimulation",
        GetAllSalesInvoicesService: "SalesInvoicesService.svc/GetAll",
        GetAllCustomerService: "CustomerService.svc/GetAll",
        GetAllOrderSubTypesService: "OrderSubTypesService.svc/GetAll",
        GetInvoiceByIdComplete:
            "SalesInvoicesService.svc/GetInvoiceByIdComplete",
        GetByProductionOrderNumberComplete:
            "RepairOrderService.svc/GetByProductionOrderNumberComplete",
        GetProductionOrderDetailsView:
            "RepairOrderService.svc/GetProductionOrderDetailsView",
        GetInvoicesForBillingByDocument:
            "SalesInvoicesService.svc/GetInvoicesForBillingByDocument",
        BillProductionOrdersInvoicesByIDs:
            "SalesInvoicesService.svc/BillProductionOrdersInvoicesByIDs",
        FindProductionOrdersForBilling:
            "RepairOrderService.svc/FindProductionOrdersForBilling",
        OpenNewCounterSaleAmendment:
            "CounterSalesService.svc/OpenNewCounterSaleAmendment",
        OpenNewCounterSaleAmendmentByParams:
            "CounterSalesService.svc/OpenNewCounterSaleAmendmentByParams",
        CreateCorrectiveInvoice:
            "SalesInvoicesService.svc/CreateCorrectiveInvoice",
        CreateCorrectiveInvoiceSimulated:
            "SalesInvoicesService.svc/CreateCorrectiveInvoiceSimulated",
        GetCounterSalesFromGroupedInvoiceById:
            "SalesInvoicesService.svc/GetCounterSalesFromGroupedInvoiceById",
        GetInvoiceDetailsInGroupedCounterSaleInvoice:
            "SalesInvoicesService.svc/GetInvoiceDetailsInGroupedCounterSaleInvoice",
        GetInvoicesHeaderByVOExpedient:
            "VOInvoicesService.svc/GetInvoicesHeaderByVOExpedient",
        CreateVOCorrectiveInvoice:
            "SalesInvoicesService.svc/CreateVOCorrectiveInvoice",
        GetInvoicesFranchiseByDocument:
            "SalesInvoicesService.svc/GetInvoicesFranchiseByDocument",
        ReopenInsuranceInvoiceWithFranchise:
            "SalesInvoicesService.svc/ReopenInsuranceInvoiceWithFranchise",
    },
};
